import React, { useRef, useState } from "react";
import { ModalHeader } from "./modal/ModalHeader";
import { CenteredText, Description } from "./styles";
import { DeleteFooter } from "./modal/footers/DeleteFooter";
import { SavedSearchModal } from "./modal/SavedSearchModal";
import { closableErrorToast, shortLivedSuccessToast } from "../utils";
import { Category } from "../model/model";
import { useSavedSearchService } from "../services/useSavedSearchService";
import { useAppTranslation } from "../locales/translate";

export interface Props {
  isOpen: boolean;
  closeModal: () => void;
  savedSearchId: number;
  savedSearchName: string;
  category: Category;
  onCancel?: () => void;
  onDelete?: (id: number) => void;
}

export const DeleteSavedSearchModal = ({
  isOpen,
  closeModal,
  savedSearchId,
  savedSearchName,
  category,
  onCancel = closeModal,
  onDelete,
}: Props) => {
  const savedSearchService = useSavedSearchService(category);
  const focusRef = useRef(null);
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false);

  const { t } = useAppTranslation();

  const deleteSavedSearch = () => {
    setIsDeleteDisabled(true);

    savedSearchService
      .deleteSavedSearch(savedSearchId)
      .then(() => setIsDeleteDisabled(false))
      .then(closeModal)
      .then(() => {
        if (onDelete) onDelete(savedSearchId);
        shortLivedSuccessToast(t("TOAST_SEARCH_DELETE_SUCCESS"));
      })
      .catch(() => closableErrorToast(t("TOAST_SEARCH_DELETE_ERROR")))
      .finally(() => setIsDeleteDisabled(false));
  };

  return (
    <SavedSearchModal
      narrow
      isOpen={isOpen}
      onDismiss={closeModal}
      focusRef={focusRef}
      body={
        <>
          <ModalHeader
            title={`${t("DELETE_SEARCH_MODAL_TITLE")} “${savedSearchName}”`}
            iconName="bin"
            focusRef={focusRef}
          />
          <CenteredText>
            <Description>{t("DELETE_SEARCH_MODAL_DESCRIPTION")}</Description>
          </CenteredText>
        </>
      }
      footer={
        <DeleteFooter
          onConfirm={deleteSavedSearch}
          onCancel={onCancel}
          deleteDisabled={isDeleteDisabled}
        />
      }
    />
  );
};
